export default {
  TABLE: {
    INTAKE: {
      COLUMN: [
        'intakeRef',
        'personName',
        'personIdentity',
        'assignedCounsellor',
        'assistantCounsellor',
        'presentingProblems',
        'latestReferralDate',
        'intakeDate',
        'latestIntakeWorkerAssignedDate',
        'intakeStatus',
        'actions',
      ],
      DATA: [
        'intakeRefAndAtRiskTags',
        'clientName',
        'identityDocument',
        'staffName',
        'assistantCounsellor',
        'presentingProblems',
        'latestReferralDate',
        'intakeDate',
        'latestIntakeWorkerAssignedDate',
        'intakeStatus',
        'showButton',
      ],
      FILTERS: [
        'centres',
        'assignedCounsellor',
        'singleSelectIntakeStatus',
        'latestOutcome',
        'riskStatus',
        'caseType',
        'assistantCounsellor',
      ],
    },
    TASK: {
      COLUMN: ['item', 'status', 'counsellor', 'date', 'actions'],
    },
    CASE: {
      COLUMN: [
        'caseNo',
        'caseRefId',
        'mainClient',
        'ljfsoIcNumber',
        'mainCounsellor',
        'dateOpened',
        'dateClosed',
        'caseType',
        'keyAssessedProblem',
        'actions',
      ],
      FILTERS: [
        'centres',
        'counsellors',
        'keyAssessedProblems',
        'caseTypes',
        'caseStates',
        'caseRiskStatus',
        'caseActivityStatus',
      ],
    },
    CLIENT: {
      COLUMN: ['name', 'ic', 'contact', 'actions'],
    },
    REPORTS: {
      CLIENT_SPECIAL_REPORT: {
        CLIENTS_TABLE_COLUMN: [
          'clientName',
          'caseNumber',
          'caseReference',
          'counsellor',
          'identityDocumentation',
          'riskStatus',
          'age',
          'maritalStatus',
          'gender',
          'individualIncome',
          'occupationStatus',
          'race',
          'religion',
          'educationLevel',
          'languages',
          'lastModifed',
          'modifiedBy',
          'actions',
        ],
      },
      INTAKE_SPECIAL_REPORT: {
        INTAKE_TABLE_COLUMN: [
          'id',
          'intake_ref',
          'client_name',
          'start_date',
          'referral_source_name',
          'last_referral_date',
          'actions',
          'not_making_appointment_reasons',
          'outcome',
          'assigned_counsellor',
          'case_type',
          'assistant_counsellor',
          'intake_remarks',
          'intake_worker_assigned_date',
        ],
        INTAKE_TABLE_ROW: [
          'id',
          'intake_ref',
          'client_name',
          'start_date',
          'referral_source_name',
          'last_referral_date',
          'actions',
          'not_making_appointment_reasons',
          'outcome',
          'assigned_counsellor',
          'case_type',
          'assistant_counsellor',
          'intake_remarks',
          'intake_worker_assigned_date',
        ],
      },
    },
  },
};
